"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertUnreachable = assertUnreachable;
function assertUnreachable(value, message) {
    throw new Error(message);
}
//# sourceMappingURL=utils.js.map